import { api } from '@/lib/axios'
import type { ExportRequest } from '@/lib/export-request'

/** AP-37 8. — Angebot erstellen, Angebote der Kalkulation, Ausdruck. */
export interface CalcOfferDraft {
  positionIds?: string[]
  groupsAsTitles?: boolean
  longTexts?: boolean
  optionals?: boolean
  clientId?: string
  contactPersonId?: string
  newClientName?: string
  markSubmitted?: boolean
}

export interface CalcOfferDocument {
  id: string
  kind: string
  status: string
  documentNumber: string | null
  documentDate: string
  createdAt: string
  revision: number
  changedAfter: boolean
}

export const createOffer = (id: string, dto: CalcOfferDraft) =>
  api.post<{ data: { documentId: string; submitted: boolean } }>(`/calculations/${id}/offer`, dto).then((r) => r.data.data)

export const fetchOffers = (id: string) => api.get<{ data: CalcOfferDocument[] }>(`/calculations/${id}/offers`).then((r) => r.data.data)

/** Ausdruck: GET für den Download, POST …/mail für den Versand (`ExportButton`). */
export const calculationPrintRequest = (id: string, params: { format?: string; orientation?: string; sheets?: boolean; scope?: 'positions' | 'closing' }): ExportRequest => ({
  url: `/calculations/${id}/export`,
  params: { ...params, sheets: params.sheets ? '1' : undefined },
})
